export function calcDiscount(teraId) {
    if (teraId.includes('UXD'))
        return '25%';
    if (teraId.includes('DTE'))
        return '20%';
    return '35%';
}
